import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/cases/quick'

const Quick: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UIUX モバイルアプリ システム化 DX推進 フロントエンド開発'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/cases/quick'}
        title="QUICK Global Alert | 事例 | i3DESIGN アイスリーデザイン"
        description="金融マーケット関係者に、世界の情報を素早くご提供するアプリを開発いたしました。このアプリは、金融関係のお客様に要求されるクラウド上での高いセキュリティレベルの実現と、Xamarinを利用した1ソースでマルチデバイス対応をしています。弊社はこのアプリ開発を実施しました。"
      />
      <Template />
    </>
  )
}

export default Quick
